import axiosInstance from '@/lib/axiosInstance';
import { AccessCode } from '@/model/AccessCode.model';
import { User } from '@/model/User.model';

export enum LoginMethod {
  AccessCode = 'accessCode',
  EmailPassword = 'emailPassword',
}

export const getAuthData = async (): Promise<{ user: User; accessCode: AccessCode }> => {
  const { data } = await axiosInstance.get('auth/data');
  const { user, accessCode } = data;
  return { user: User.fromJson(user), accessCode: AccessCode.fromJson(accessCode) };
};

export const loginWithAccessCode = async (
  code: string,
  method = LoginMethod.AccessCode
): Promise<{ user: User; accessCode: AccessCode; customToken: string }> => {
  const { data } = await axiosInstance.post('login', { code }, { params: { method } });
  const { user, accessCode, customToken } = data;
  return { user: User.fromJson(user), accessCode: AccessCode.fromJson(accessCode), customToken };
};
